import { createContext, useContext } from 'react';

type BaseCardContextType = {
  bookmarks: {
    allowUndo: boolean;
  };
};

const DEFAULT_CONTEXT_VALUE = {
  bookmarks: {
    allowUndo: false,
  },
};

const BaseCardContext = createContext<BaseCardContextType>(DEFAULT_CONTEXT_VALUE);

export function useBaseCardContext() {
  const context = useContext(BaseCardContext);

  return context;
}

export default BaseCardContext;
